import {useLocation} from 'react-router-dom';
import {parseQueryToFilters} from '../infrastructure/filterUrlMapper';

export function useInitialFilters() {
    const location = useLocation();
    // Solo el catalogo hidrata los filtros GLOBALES desde la URL. Ofertas y Nuevos usan
    // los mismos parametros (se, tmf...) pero con estado propio: sin esto, entrar en
    // /promociones?se=... rellenaba el buscador global de la cabecera y abria su
    // desplegable de sugerencias solo.
    if (!location.pathname.startsWith('/articulos')) return {};
    return parseQueryToFilters(new URLSearchParams(location.search));
}